module.exports = {
	"INLINE": "Testesssss",
	"nav_home": "Inizio",
	"nav_menu": "Menù",
	"nav_about": "Ristorante",
	"nav_wines": "Vino",
	"nav_suggestions": "Suggerimenti",
	"nav_events": "Eventi",
	"nav-feedback": "Tua opinione",
	"follow_text": "Seguici",
	"desktop_languages": "Le lingue",
	"intro_default_option": "Filtra menu per:",
	"suggested_extras": "Contorni suggeriti",
	"suggested_wines": "Vini suggeriti",
	"cta_title": "Vedi la nostra selezione di ",
	"cta_btn": "Vedere",
	"related_products": "Prodotti Simili",
	"error_home_link": "Torna all'inizio",
	"error_home_title1": "Hmm...",
	"error_home_title2": "Impossibile trovare la pagina che stai cercando.",
	"error_home_text": "Prova a riscrivere l'indirizzo o riprova più tardi.",
	"detail_title": "nei dettagli",
	"list_event_title": "Eventi",
	"event_link": "Pagina ufficiale",
	"other_events": "Altri eventi",
	"filters": "Filtri",
	"filter-group-region-type": "Tipo di vino e regione",
	"region_default_option": "Scegli una regione",
	"filter-group-type": "Genere",
	"type_default_option": "Scegli un tipo",
	"filter-group-flavour": "Gusto",
	"filter-group-characteristics": "Caratteristiche del vino",
	"sweetness_default_option": "Acidità",
	"filter-group-body": "Corpo",
	"body_default_option": "Scegli il corpo",
	"filter-group-ingredients": "Ingredienti principali",
	"filter-group-diets": "intolleranze",
	"filter-results": "{results} risultati",
	"filter-clear-button": "Cancella filtri",
	"filter-apply-button": "Applicare",
	"related_dishes": "Piatti Consigliati",
	"empty-title": "Nessun risultato",
	"empty-text": "Al momento non abbiamo risultati da mostrarti, per favore riprova con nuovi parametri.",
	"feedback-title": "Aiutaci a migliorare",
	"feedback-intro": "Lasciaci le tue critiche e opinioni in modo che possiamo migliorare Pickly per te.",
	"feedback-improve": "Pickly ha migliorato la tua esperienza al ristorante?",
	"feedback-error": "Per favore, scegli un'opzione",
	"feedback-harder": "Complicato",
	"feedback-no-help": "Non ha aiutato",
	"feedback-indiferent": "Indifferente",
	"feedback-helped": "Aiutato",
	"feedback-helped-a-lot": "Aiutato molto",
	"feedback-recommend": "Consiglieresti ad altri ristoranti di usare Pickly?",
	"feedback-no-recommend": "Non lo consiglio",
	"feedback-recommend-neutral": "Indifferente",
	"feedback-recommend-yes": "Io raccomando",
	"feedback-msg": "Lasciaci la tua opinione sulla tua esperienza e su come pensi che potremmo migliorare l'applicazione. (opzionale) ",
	"feedback-submit": "Invia",
	"feedback-thanks-title": "Grazie",
	"feedback-thanks-text": "Grazie per aiutarci a migliorare! Puoi tornare all'inizio usando il pulsante qui sotto.",
	"restaurant-feedback-title": "La tua opinione è importante",
	"restaurant-feedback-subtitle": "Aiutaci a migliorare.",
	"restaurant-feedback-intro": "Raccontaci della tua esperienza nel nostro ristorante, valutando il servizio, il cibo e l'ambiente, attraverso un breve questionario.",
	"restaurant-feedback-intro-btn": "Dare un feedback",
	"food-feedback-title": "Valutazione degli alimenti",
	"food-feedback-intro": "Dai la tua opinione e aiutaci a migliorare.",
	"choice-question": "Il menu offriva una buona selezione di piatti",
	"presentation-question": "I piatti hanno avuto una buona presentazione",
	"tasty-question": "Il cibo era gustoso e ben preparato",
	"service-feedback-title": "Valutazione del SERVIZIO",
	"speed-question": "Sono stati rapidi nel gestire la nostra richiesta",
	"waiters-question": "I dipendenti erano cordiali e attenti",
	"overall-question": "Nel complesso, il servizio è stato buono",
	"global-feedback-title": "Valutazione GLOBALE",
	"deco-question": "Il ristorante aveva una buona atmosfera e arredamento",
	"price-question": "Il rapporto qualità / prezzo era buono",
	"recommend-question": "Consiglierei il ristorante ad un amico",
	"comments-question": "Commenti e suggerimenti",
	"recommend_title": "Consiglieresti questo piatto?",
	"recommend-total": "{total} i clienti raccomandano questo piatto.",
	"type": "genere",
	"body": "corpo",
	"region": "regione",
	"accidity": "acidità",
	"mypick-text": "Con myPick selezioni i tuoi piatti, bevande e dessert preferiti per questo pasto. Quindi basta chiedere al cameriere.",
	"cookie-notice": "Utilizzando questo sito, acconsenti all'uso dei cookie per analisi e statistiche.",
	"terms-title": "Termini e condizioni",
	"price_under_request": "Prezzo su richiesta"
};


/*****************
 ** WEBPACK FOOTER
 ** ./locales/it-it.json
 ** module id = 277
 ** module chunks = 0
 **/